'use client'

import React, { useEffect, useState } from 'react'
import Image from 'next/image'
import { Button, notification, message } from 'antd'
import { AddWishAction } from '@/actions/shop'
import { useRouter, usePathname } from 'next/navigation'
import { useUserStore } from '@/stores/user-store-provider'
import { loginToRedirectUrl } from '@/utils/index'
import { useTranslation } from '@/i18n/client'
import FivePointedStarSvg from '@/public/icons/fivePointedStar.svg'

export default function WishButton({ bookName, bookId, lng, type = 'default' }: { bookName: string; bookId: number | number[]; lng: string; type: string }) {
  const { t } = useTranslation(lng)
  const router = useRouter()
  const curPath = usePathname()
  const { isLogin } = useUserStore((state) => state)
  const [api, contextHolder] = notification.useNotification({ top: 90 })
  const [success, setSuccess] = useState(false)

  const addFavorite = async (bookId: number | number[]) => {
    if (!isLogin) {
      loginToRedirectUrl(router, curPath)
      return
    }

    let lastError = ''
    if (Array.isArray(bookId)) {
      // 使用 Promise.allSettled 并行处理所有请求
      const promises = bookId.map((id) => AddWishAction({ bookId: id }))
      const results = await Promise.allSettled(promises)
      // 检查是否所有请求都成功
      const allSuccess = results.every((result) => result.status === 'fulfilled' && result.value.success)
      // 错误信息
      for (const result of results) {
        if (result.status === 'fulfilled') {
          const { success, errorLangs } = result.value
          if (!success) {
            lastError = errorLangs[lng]
          }
        }
      }
      if (allSuccess) {
        setSuccess(true)
      }
    } else {
      const { success, errorLangs } = await AddWishAction({ bookId })
      if (success) {
        setSuccess(true)
      } else {
        lastError = errorLangs[lng]
      }
    }
    if (lastError) {
      message.error(lastError)
    }
  }

  useEffect(() => {
    if (success) {
      api.open({
        message: '',
        description: (
          <p className="pr-[30px] leading-[20px]">
            {bookName} <span className="text-red">{t('addWishListSuccess')}</span>
          </p>
        ),
        className: 'endao-notice',
        duration: 3,
        style: {
          padding: '4px 0 12px 20px',
          width: 256,
          fontSize: 13,
          borderRadius: 5,
          border: '1px solid #ffc6cc'
        }
      })
      setSuccess(false)
    }
  }, [success])

  return (
    <>
      {contextHolder}
      {type === 'round' && <Button shape="round" icon={<FivePointedStarSvg className="relative top-[1px]" />} className="bookDetail" title={t('addToWishList')} onClick={() => addFavorite(bookId)} />}
      {type === 'circle' && (
        <span title={t('addToWishList')} className="flex h-[32px] w-[32px] cursor-pointer items-center justify-center rounded-[50%] border border-gray transition-all duration-[400ms] hover:!bg-[#f7f7f7]" onClick={() => addFavorite(bookId)}>
          <FivePointedStarSvg className="relative left-[1px]" />
        </span>
      )}
    </>
  )
}
